import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import {Link} from "react-router-dom";

const socialmedia = [
    {
        name:"Facebook",
        icon:<FiFacebook />,
        link:"https://www.facebook.com/IEEE.SB.ISSATSO",
    },
    {
        name:"Twitter",
        icon:<FiTwitter />,
        link:"https://twitter.com/ieee_issatso_sb",
    },
    {
        name:"Instagram",
        icon:<FiInstagram />,
        link:"https://www.instagram.com/ieee.issatso.student.branch/",
    },
    {
        name:"Linkedin",
        icon:<FiLinkedin />,
        link:"https://www.linkedin.com/company/ieee-issatso/",
    },

]
const Copyright = () => {
    return (
        <div className="copyright-area copyright-style-one variation-two">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-7 col-sm-12 col-12">
                        <div className="copyright-left">
                            <ul className="ft-menu link-hover">
                                <li><a href='https://www.ieee.org/about/help/site-terms-conditions.html' target='_blank'>Terms Conditions</a></li>
                                <li><a href='https://www.ieee.org/security-privacy.html' target='_blank'>Privacy Policy</a></li>
                                <li><Link to='/contact'>Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5 mt_sm--20">
                        <div className="copyright-center text-center">
                            <ul className="social-icon social-default color-lessdark justify-content-center" >
                            {socialmedia.map((data, index)=>
                                <li key={index}><Link target="_blank" to={{pathname: data.link}}>{data.icon}</Link></li>)}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12 mt_md--20 mt_sm--20">
                        <div className="copyright-right text-center text-lg-right">
                            <p className="copyright-text">Copyright All rights reserved © {new Date().getFullYear()} <strong>IEEE ISSATSo</strong>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Copyright;